import { config } from '@uhg-abyss/web/tools/config';
import { checkIsInternal } from "@src/utility/createStorage";
import httpService from "@src/utility/httpService";
import APP_CONSTANT from './constant';
const _httpService = new httpService();

if (checkIsInternal()) {
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else {
    _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}

export const getOnboardingDetails = (page: string) => {
    const fetchData = async () => {
        try {
            const response: any = await _httpService.get(`/onboarding-details/?page=${page}`);
            return response;
        } catch {
            return null;
        }
    }
    return fetchData();
};
export const getImageName = (imagePath: string) => {
    const imageName = imagePath?.split('/').pop()?.replace(/\.[^.]+$/, '');
    return (imageName && APP_CONSTANT.IMAGES[imageName]) || imagePath;
};